import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormGroup, Label, FormText } from 'reactstrap';
import { Field, change } from 'redux-form';
import Autosuggest from 'react-autosuggest';
import * as Actions from '../../actions/schoolAutoSuggestActions';
import { required, Required } from '../../helpers/formHelper';
import GradeList from '../../helpers/GradeList';

class View extends Component {
  constructor(props) {
    super(props);
    this.schoolNameInput = React.createRef();
    const { formValues } = this.props;
    if (formValues.student !== undefined) {
      this.state = { schoolName: formValues.student.school_name };
    } else if (formValues.parent_status !== undefined
        && formValues.parent_status.student_statuses_attributes !== undefined
        && formValues.parent_status.student_statuses_attributes[0].student_attributes !== undefined) {
      this.state = { schoolName: formValues.parent_status.student_statuses_attributes[0].student_attributes.school_name };
    } else {
      this.state = { schoolName: '' };
    }
  }

  getSelectedSchoolName() {
    const { formValues, schools } = this.props;
    const { school_id } = formValues.school_x_subscription;
    if (schools.length === 0 || school_id === null || school_id === undefined || school_id === '') {
      return '日程・学校・コース情報の開催学校名を選択してください';
    }
    const school = schools.find((x) => x.id === parseInt(school_id, 10));
    if (school === undefined) {
      return '';
    }
    return school.name;
  }

  render() {
    const {
      formName, schoolGradeInputName, schoolNameInputName, gradeList, onChangeSchoolName, schoolNames, getSchoolNames, loadingSchoolNames, resetSchoolNames,
    } = this.props;
    return formName !== 'schoolXEntryIndex' ? (
      <>
        <FormGroup>
          <Label>学年</Label>
          <Required />
          <GradeList
            id="student_grade"
            name={schoolGradeInputName}
            schoolName={this.state.schoolName}
            gradeList={gradeList}
          />
        </FormGroup>
        <FormGroup>
          <Label>学校名</Label>
          <Required />
          <Field
            id="student_school_name"
            name={schoolNameInputName}
            type="hidden"
            component="input"
            validate={[required]}
          />
          <Autosuggest
            valid
            ref={this.schoolNameInput}
            name="school_name_dummy"
            suggestions={schoolNames}
            inputProps={{
              placeholder: '学校名を入力',
              value: this.state.schoolName,
              onChange: (e, { newValue }) => {
                this.setState({ schoolName: newValue });
                onChangeSchoolName(formName, schoolNameInputName, newValue);
              },
            }}
            getSuggestionValue={(suggestion) => suggestion.label}
            onSuggestionsFetchRequested={({ value }) => getSchoolNames(formName, value)}
            onSuggestionsClearRequested={resetSchoolNames}
            renderSuggestion={(suggestion) => <div>{suggestion.label}</div>}
            isLoading={loadingSchoolNames}
          />
          <FormText>
            入力を始めると学校名のリストが表示されますので、その中から学校名を選択してください。
            <br />
            リストに学校名がない場合は直接ご入力ください。
          </FormText>
        </FormGroup>
      </>
    ) : (
      <>
        <FormGroup>
          <Label>学年</Label>
          <Required />
          <GradeList
            id="student_grade"
            name="student[grade]"
            schoolName={this.getSelectedSchoolName()}
            gradeList={gradeList}
          />
        </FormGroup>
        <FormGroup>
          <Label>学校名</Label>
          <Field name="student[school_name]" type="hidden" component="input" />
          <FormText style={{ fontSize: '1rem' }}>{this.getSelectedSchoolName()}</FormText>
        </FormGroup>
      </>
    );
  }
}

View.defaultProps = {
  schools: null,
};

View.propTypes = {
  formName: PropTypes.string.isRequired,
  schoolNameInputName: PropTypes.string.isRequired,
  schoolGradeInputName: PropTypes.string.isRequired,
  formValues: PropTypes.shape({
    authenticity_token: PropTypes.string,
  }).isRequired,
  onChangeSchoolName: PropTypes.func.isRequired,
  schoolNames: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  })).isRequired,
  getSchoolNames: PropTypes.func.isRequired,
  loadingSchoolNames: PropTypes.bool.isRequired,
  resetSchoolNames: PropTypes.func.isRequired,
  gradeList: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]))).isRequired,
  schools: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    disabled: PropTypes.bool,
  })),
};

export default connect((state) => ({
  schoolNames: state.schoolAutoSuggest.schoolNames,
  loadingSchoolNames: state.schoolAutoSuggest.loadingSchoolNames,
}), (dispatch) => ({
  onChangeSchoolName: (formName, schoolNameInputName, value) => dispatch(change(formName, schoolNameInputName, value)),
  resetSchoolNames: () => dispatch(Actions.setSchoolNames([])),
  getSchoolNames: (formName, value) => dispatch({
    type: Actions.SAGA_GET_SCHOOL_NAMES,
    payload: {
      formName,
      value,
    },
  }),
}))(View);
